// Tempatkan di: src/util/dataCustomerSj.js
// Satu sumber data customer untuk PdfSuratJalan dan PdfSuratJalanManual.
export const dataCustomer = [
  {
    customer: "CBI",
    name: "PT.CENTURY BATTERIES I",
    alamat: "JL.MITRA RAYA SELATAN 1 BLOK E / NO.17-19 KARAWANG",
    tlp: "(025)-29488812",
  },
  {
    customer: "COMPOTEC",
    name: "PT.COMPOTEC INDONESIA",
    alamat:
      "Jl. Neglasari II No. 6 (Jl. Raya Bogor KM 52), Kedung Halang, Kabupaten Bogor, Jawa Barat 16710",
    tlp: "0251-8665663",
  },
  {
    customer: "GS",
    name: "PT.GS BATTERY",
    alamat: "JL.SURYA UTAMA KAV.13-14 TELUK JAMBE KARAWANG",
    tlp: "0267-440961",
  },
  {
    customer: "TBP",
    name: "PT.TRIMITRA BATERAI P.",
    alamat: "JL.SEMPER TIMUR NO.3 CILINCING - JAKARTA",
    tlp: "(025)-4403066",
  },
  {
    customer: "YBI",
    name: "PT.YUASA BATTERY IND",
    alamat: "JL.MH THAMRIN NO.1 TANGERANG - BANTEN",
    tlp: "(025)-55757255",
  },
  {
    customer: "MELCO",
    name: "PT.MELCOINDA",
    alamat: "JL.DESA SENTUL NO.77 BOGOR - INDONESIA",
    tlp: "(021)-8762510",
  },
  {
    customer: "GSS",
    name: "PT.GS BATTERY",
    alamat:
      "KAWASAN INDUSTRI BUKIT SEMARANG BARU BLOK B3, KEL. JATIBARANG KEC. MIJEN KOTA SEMARANG JAWA TENGAH",
    tlp: "(025)-76439560",
  },
  {
    customer: "TIM2",
    name: "PT.TIM 2",
    alamat: "JL.KARANGGAN RT 01/02 NO.3 PUSPASARI - CITEUREUP BOGOR",
    tlp: "87909811",
  },
  {
    customer: "TIM1",
    name: "PT.TIM 1",
    alamat: "JL. Kapitan No. 88 RT. 02/05 Curug-Cimanggis Depok",
    tlp: "(021)-8743449",
  },
];
